export const confirmPrivacyPolicy = (state) => state.confirmPrivacyPolicy

export const getUserOrgas = (state) => state.userOrgas

export const getActiveOrga = (state) => state.activeOrga

export const getVersion = (state) => state.version

export const getServerVersion = (state) => state.serverVersion

export const now = (state) => state.now

export const language = (state) => state.language

export const isLoading = (state, getters) => {
  return getters['resource/isLoading'] ||
         getters['list/isLoading'] ||
         getters['editor/isLoading'] ||
         getters['user/isLoading'] ||
         getters['publicView/isLoading'] ||
         getters['publicView/isLoadingStaff'] ||
         getters['tree/isLoading'] ||
         getters['aboutme/isLoading']
}

export const getMainMenu = (state, getters, rootState) => {
  return [
    {
      name: 'menu.start',
      icon: 'fa fa-home',
      link: '/',
      exact: true
    },
    {
      name: 'menu.aboutme',
      icon: 'fa fa-user',
      link: { name: 'aboutme' },
      auth: true,
      exact: true,
      disabled: !rootState.user.forscher
    },
    {
      name: 'menu.login',
      icon: 'fa fa-key',
      link: { name: 'login' },
      auth: false,
      exact: true
    },
    {
      name: 'menu.list',
      link: { name: 'auflisten' },
      icon: 'fa fa-table',
      auth: true
    },
    {
      name: 'menu.details',
      link: { name: 'anzeigen' },
      icon: 'fa fa-search',
      auth: true
    },
    {
      name: 'menu.editor',
      marked: getters['editor/isDirty'],
      link: '/bearbeiten',
      icon: 'fa fa-pencil-square-o',
      classes: getters['editor/isDirty'] ? ['fob-text-italic'] : [],
      auth: true
    },
    {
      name: 'menu.create',
      marked: getters['creator/isDirty'],
      link: { name: 'eintragen' },
      icon: 'fa fa-file-o',
      classes: getters['creator/isDirty'] ? ['fob-text-italic'] : [],
      auth: true
    },
    {
      name: 'menu.upload',
      link: '/upload',
      icon: 'fa fa-upload',
      auth: true
    },
    {
      name: 'menu.help',
      link: '/help',
      icon: 'fa fa-question-circle',
      auth: true
    }
    // Deactivated until further notice
    // {
    //   name: 'menu.report',
    //   link: '/berichte',
    //   icon: 'fa fa-list-ul',
    //   auth: true
    // }
  ]
  .filter(item =>
    typeof item.auth === 'undefined' ||
    item.auth === getters['user/isAuthorized'])
}



// WEBPACK FOOTER //
// ./src/store/getters.js